module.exports = __webpack_public_path__ + "static/media/premiumCurve.a1e5d97c.svg";